/**
 * fc-bundle-box.js
 * 2-for-₱7,000 Bundle Box — interaction logic.
 * Reads product data from window.FC_BUNDLE_PRODUCTS (set by fc-bundle-box.liquid).
 * Reads config from window.FC_BUNDLE_CONFIG.
 */
(function () {
  'use strict';

  /* ─── Built-in color name → hex map ─────────────────── */
  var COLOR_NAME_MAP = {
    'black':      '#111111',
    'white':      '#FFFFFF',
    'navy':       '#1B2A4A',
    'navy blue':  '#1B2A4A',
    'grey':       '#9E9E9E',
    'gray':       '#9E9E9E',
    'light grey': '#D1D5DB',
    'light gray': '#D1D5DB',
    'charcoal':   '#36454F',
    'red':        '#DC2626',
    'blue':       '#2563EB',
    'light blue': '#93C5FD',
    'sky blue':   '#87CEEB',
    'royal blue': '#1E40AF',
    'green':      '#16A34A',
    'olive':      '#6B7028',
    'brown':      '#92400E',
    'tan':        '#D2B48C',
    'beige':      '#F5F0E8',
    'cream':      '#FFFDD0',
    'off white':  '#F8F5F0',
    'pink':       '#EC4899',
    'rose':       '#FB7185',
    'purple':     '#9333EA',
    'orange':     '#F97316',
    'yellow':     '#EAB308',
    'gold':       '#D4AF37',
    'silver':     '#C0C0C0',
    'maroon':     '#800000',
    'burgundy':   '#800020',
    'teal':       '#0D9488',
    'coral':      '#FF6B6B',
    'khaki':      '#C3B091',
    'camel':      '#C19A6B',
    'mint':       '#98FFB3',
    'lavender':   '#E6E6FA',
    'sand':       '#C2B280',
    'stone':      '#A8A09A',
    'slate':      '#64748B',
    'cobalt':     '#0047AB',
    'emerald':    '#50C878',
  };

  /* ─── Config ─────────────────────────────────────────── */
  var CFG = window.FC_BUNDLE_CONFIG || {};
  var PRODUCTS     = window.FC_BUNDLE_PRODUCTS || [];
  var DISCOUNT     = CFG.discountCode  || 'FC7KBUNDLEB';
  var CHECKOUT_URL = CFG.checkoutUrl   || '/checkout';

  /* ─── State ──────────────────────────────────────────── */
  var box         = [null, null];   // 2 slots
  var pending     = null;           // product being configured
  var replaceSlot = null;           // slot index to replace (0 or 1)
  var selColor    = null;
  var selSize     = null;
  var hasColors   = false;

  /* ─── localStorage persistence ──────────────────────── */
  var STORAGE_KEY = 'fc_bundle_box';

  function saveBox() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(box)); } catch (e) {}
  }

  function loadBox() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) return;
      var parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length === 2) {
        box = parsed;
      }
    } catch (e) {
      // Corrupted data — start fresh
      try { localStorage.removeItem(STORAGE_KEY); } catch (e2) {}
    }
  }

  function clearSavedBox() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* ─── Build a variant lookup map for a product ───────── */
  function buildVariantMap(product) {
    /* Returns an object so we can look up variantId by:
     *   variantMap[colorVal][sizeVal]   — when 2 options (Color + Size)
     *   variantMap[sizeVal]             — when 1 option (Size only)
     */
    var map = {};
    var opts = product.options || [];
    var colorIdx = -1;
    var sizeIdx  = -1;

    opts.forEach(function (name, i) {
      var n = name.toLowerCase().trim();
      // Matches: "Color", "Colour", "Shoe Color", etc.
      if (n === 'color' || n === 'colour' || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) colorIdx = i;
      // Matches: "Shoe size", "Size", "UK Size", "EU Size", etc.
      if (n === 'shoe size' || n === 'size' || n.indexOf('size') !== -1) sizeIdx = i;
    });

    product.variants.forEach(function (v) {
      var o = [v.option1, v.option2, v.option3];
      if (colorIdx !== -1 && sizeIdx !== -1) {
        var c = o[colorIdx] || '';
        var s = o[sizeIdx]  || '';
        if (!map[c]) map[c] = {};
        map[c][s] = { id: v.id, available: v.available };
      } else if (sizeIdx !== -1) {
        var s = o[sizeIdx] || '';
        map[s] = { id: v.id, available: v.available };
      } else {
        // No recognised option — map by option1
        var k = o[0] || 'Default';
        map[k] = { id: v.id, available: v.available };
      }
    });
    return map;
  }

  /* ─── Tab filtering ─────────────────────────────────── */
  window.fcBundleFilterTab = function (cat, btn) {
    document.querySelectorAll('.fc-bundle-tab-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');

    document.querySelectorAll('.fc-bundle-card').forEach(function (card) {
      var tags = (card.dataset.tags || '').split(',').map(function (t) { return t.trim(); });
      var show = (cat === 'all') || tags.indexOf(cat) !== -1;
      if (show) card.classList.remove('fc-bc-hidden');
      else       card.classList.add('fc-bc-hidden');
    });

    renderCards(); // re-evaluate dimming
  };

  /* ─── Open picker ────────────────────────────────────── */
  window.fcBundleOpenPicker = function (btn) {
    var card = btn.closest('.fc-bundle-card');
    if (!card) return;
    var pid     = Number(card.dataset.pid);
    var product = PRODUCTS.find(function (p) { return p.id === pid; });
    if (!product) return;

    // Read color hex map from the card's rendered color dots — avoids any JSON/HTML quoting issues
    var colorHexMap = {};
    card.querySelectorAll('.fc-bundle-color-dot-sm').forEach(function (dot) {
      var name = dot.getAttribute('title');
      var bg   = dot.style.background || dot.style.backgroundColor;
      if (name && bg) colorHexMap[name] = bg;
    });

    pending = {
      pid:          pid,
      product:      product,
      card:         card,
      varMap:       buildVariantMap(product),
      colorHexMap:  colorHexMap,
    };
    selColor = null;
    selSize  = null;

    if (box[0] && box[1]) {
      // Both full — ask which to replace
      showReplace();
    } else {
      showPicker();
    }
  };

  /* ─── Picker modal ───────────────────────────────────── */
  function showPicker() {
    var p     = pending.product;
    var imgEl = document.getElementById('fcb-modal-img');

    // Modal product info
    document.getElementById('fcb-modal-name').textContent  = p.title;

    if (imgEl && p.image) {
      imgEl.innerHTML = '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '">';
    } else if (imgEl) {
      imgEl.innerHTML = '';
    }

    // Determine options
    var opts     = p.options || [];
    var colorIdx = -1;
    var sizeIdx  = -1;
    opts.forEach(function (name, i) {
      var n = name.toLowerCase().trim();
      if (n === 'color' || n === 'colour' || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) colorIdx = i;
      if (n === 'shoe size' || n === 'size' || n.indexOf('size') !== -1) sizeIdx = i;
    });

    hasColors = colorIdx !== -1;

    // Build color → first-variant-image map
    var colorToImage = {};
    p.variants.forEach(function (v) {
      if (!v.image) return;
      var cv = (colorIdx === 0 ? v.option1 : colorIdx === 1 ? v.option2 : v.option3) || '';
      if (cv && !colorToImage[cv]) colorToImage[cv] = v.image;
    });
    pending.colorToImage = colorToImage;

    // Build unique color values
    var colorSec = document.getElementById('fcb-color-section');
    var cGrid    = document.getElementById('fcb-color-grid');
    var cLabel   = document.getElementById('fcb-selected-color-name');

    if (hasColors) {
      colorSec.style.display = '';
      cLabel.textContent     = 'select one';
      cGrid.innerHTML        = '';
      var seenColors         = {};

      p.variants.forEach(function (v) {
        var colorVal = (colorIdx === 0 ? v.option1 : colorIdx === 1 ? v.option2 : v.option3) || '';
        if (!colorVal || seenColors[colorVal]) return;
        // Hide color if it has no available size at all
        var hasStock = p.variants.some(function (vv) {
          var cv = (colorIdx === 0 ? vv.option1 : colorIdx === 1 ? vv.option2 : vv.option3) || '';
          return cv === colorVal && vv.available;
        });
        if (!hasStock) return;
        seenColors[colorVal] = true;

        var sw = document.createElement('button');
        sw.className = 'fc-bundle-color-swatch';
        sw.title     = colorVal;
        sw.setAttribute('aria-label', colorVal);
        sw.dataset.colorVal = colorVal;

        // Hex priority: Liquid swatch metaobject → built-in name map → single-word CSS name → grey
        var colorKey = colorVal.toLowerCase();
        var hex = (pending.colorHexMap && pending.colorHexMap[colorVal])
          || COLOR_NAME_MAP[colorKey]
          || (colorKey.indexOf(' ') === -1 ? colorKey : null)
          || '#cccccc';
        sw.style.background = hex;

        sw.onclick = function () {
          document.querySelectorAll('.fc-bundle-color-swatch').forEach(function (s) {
            s.classList.remove('selected');
          });
          sw.classList.add('selected');
          selColor = colorVal;
          cLabel.textContent = colorVal;
          // Swap modal image to this color's variant image
          var varImg = pending.colorToImage && pending.colorToImage[colorVal];
          if (varImg && imgEl) {
            imgEl.innerHTML = '<img src="' + varImg + '" alt="' + escapeHtml(colorVal) + '">';
          }
          renderSizeGrid(colorVal);
          updateConfirmBtn();
        };
        cGrid.appendChild(sw);
      });
    } else {
      colorSec.style.display = 'none';
      selColor = 'Default';
    }

    // Build size grid
    renderSizeGrid(null);
    document.getElementById('fcb-selected-size-name').textContent = 'pick a color first';

    updateConfirmBtn();
    document.getElementById('fcb-picker-modal').classList.add('open');
  }

  function renderSizeGrid(selectedColor) {
    var p        = pending.product;
    var varMap   = pending.varMap;
    var sGrid    = document.getElementById('fcb-size-grid');
    var sLabel   = document.getElementById('fcb-selected-size-name');
    sGrid.innerHTML = '';
    selSize = null;
    sLabel.textContent = 'select one';

    var sizes = [];
    var opts  = p.options || [];
    var sizeIdx = -1;
    opts.forEach(function (name, i) {
      var n = name.toLowerCase().trim();
      if (n === 'shoe size' || n === 'size' || n.indexOf('size') !== -1) sizeIdx = i;
    });

    if (sizeIdx === -1) {
      // No size option — only one choice
      var btn = document.createElement('button');
      btn.className   = 'fc-bundle-size-btn';
      btn.textContent = 'One Size';
      btn.onclick = function () {
        document.querySelectorAll('.fc-bundle-size-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selSize = 'One Size';
        sLabel.textContent = 'One Size';
        updateConfirmBtn();
      };
      sGrid.appendChild(btn);
      return;
    }

    // Collect unique size values in order
    var seen = {};
    p.variants.forEach(function (v) {
      var sVal = (sizeIdx === 0 ? v.option1 : sizeIdx === 1 ? v.option2 : v.option3) || '';
      if (sVal && !seen[sVal]) { seen[sVal] = true; sizes.push(sVal); }
    });

    sizes.forEach(function (sVal) {
      var available = true;
      if (hasColors && selectedColor && varMap[selectedColor]) {
        var entry = varMap[selectedColor][sVal];
        available = entry ? entry.available : false;
      } else if (!hasColors) {
        var entry = varMap[sVal];
        available = entry ? entry.available : false;
      }

      // Skip sizes with no stock entirely
      if (!available) return;

      var btn = document.createElement('button');
      btn.className   = 'fc-bundle-size-btn';
      btn.textContent = sVal;

      btn.onclick = function () {
        document.querySelectorAll('.fc-bundle-size-btn').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        selSize = sVal;
        sLabel.textContent = sVal;
        updateConfirmBtn();
      };
      sGrid.appendChild(btn);
    });
  }

  function updateConfirmBtn() {
    var btn   = document.getElementById('fcb-confirm-btn');
    var ready = selSize && (!hasColors || selColor);
    btn.disabled = !ready;

    if (ready) {
      var label = 'Add to Box';
      if (selColor && hasColors) label += ' — ' + selColor;
      if (selSize)               label += ' / ' + selSize;
      label += ' →';
      btn.textContent = label;
    } else if (!selSize && (!hasColors || selColor)) {
      btn.textContent = 'Select a size to continue';
    } else {
      btn.textContent = 'Select color & size to continue';
    }
  }

  window.fcBundleClosePicker = function () {
    document.getElementById('fcb-picker-modal').classList.remove('open');
    pending     = null;
    selColor    = null;
    selSize     = null;
    replaceSlot = null;
  };

  /* ─── Confirm add to box ─────────────────────────────── */
  window.fcBundleConfirmAdd = function () {
    if (!pending || !selSize) return;

    var slot = replaceSlot !== null
      ? replaceSlot
      : box.findIndex(function (s) { return s === null; });

    if (slot === -1) return;

    // Get variant ID
    var varMap = pending.varMap;
    var variantEntry;
    if (hasColors && selColor && selColor !== 'Default') {
      variantEntry = varMap[selColor] && varMap[selColor][selSize];
    } else {
      variantEntry = varMap[selSize] || varMap['Default'];
    }
    if (!variantEntry) {
      console.warn('[FC Bundle] Variant not found for', selColor, selSize);
      return;
    }

    // Use the selected variant's image if available, fall back to product image
    var variantImage = (pending.colorToImage && selColor && pending.colorToImage[selColor])
      || variantEntry.image
      || pending.product.image;

    box[slot] = {
      pid:       pending.product.id,
      title:     pending.product.title,
      image:     variantImage,
      variantId: variantEntry.id,
      color:     (hasColors && selColor !== 'Default') ? selColor : null,
      size:      selSize,
    };

    replaceSlot = null;
    saveBox();
    window.fcBundleClosePicker();
    window.fcBundleCloseReplace();
    renderOverlay();
    renderCards();
  };

  /* ─── Replace modal ──────────────────────────────────── */
  function showReplace() {
    [0, 1].forEach(function (i) {
      var item = box[i];
      var imgEl = document.getElementById('fcb-replace-img-' + i);
      if (imgEl && item.image) {
        imgEl.innerHTML = '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '">';
      }
      document.getElementById('fcb-replace-name-' + i).textContent   = item.title;
      var det = item.size;
      if (item.color) det = item.color + ' / ' + det;
      document.getElementById('fcb-replace-detail-' + i).textContent = det;
    });
    document.getElementById('fcb-replace-modal').classList.add('open');
  }

  window.fcBundleDoReplace = function (slotIdx) {
    replaceSlot = slotIdx;
    window.fcBundleCloseReplace();
    showPicker();
  };

  window.fcBundleCloseReplace = function () {
    document.getElementById('fcb-replace-modal').classList.remove('open');
  };

  /* ─── Remove from slot ───────────────────────────────── */
  window.fcBundleRemoveSlot = function (i) {
    if (!box[i]) return;
    box[i] = null;
    saveBox();
    renderOverlay();
    renderCards();
  };

  /* ─── Render overlay ─────────────────────────────────── */
  function renderOverlay() {
    var filled = box.filter(Boolean).length;

    // Progress
    var pf = document.getElementById('fcb-progress-fill');
    if (pf) pf.style.width = (filled / 2 * 100) + '%';

    var countEl = document.getElementById('fcb-selected-count');
    if (countEl) countEl.textContent = filled + ' of 2 pairs selected';

    // Slots
    [0, 1].forEach(function (i) {
      var slotEl = document.getElementById('fcb-slot-' + i);
      if (!slotEl) return;
      var item = box[i];

      if (item) {
        slotEl.classList.add('filled');
        var det = item.size;
        if (item.color) det = item.color + ' / ' + det;
        var imgHtml = item.image
          ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '">'
          : '';

        slotEl.innerHTML =
          '<div class="fc-bundle-slot-label">Pair ' + (i + 1) + '</div>' +
          '<div class="fc-bundle-slot-img">' + imgHtml + '</div>' +
          '<div class="fc-bundle-slot-info">' +
            '<div class="fc-bundle-slot-name">' + escapeHtml(item.title) + '</div>' +
            '<div class="fc-bundle-slot-detail">' + escapeHtml(det) + '</div>' +
          '</div>' +
          '<button class="fc-bundle-slot-remove" onclick="fcBundleRemoveSlot(' + i + ')" aria-label="Remove">✕</button>';
      } else {
        slotEl.classList.remove('filled');
        slotEl.innerHTML =
          '<div class="fc-bundle-slot-label">Pair ' + (i + 1) + '</div>' +
          '<div class="fc-bundle-slot-empty">+ Add ' + (i === 0 ? 'first' : 'second') + ' pair</div>';
      }
    });

    // Checkout button
    var btn = document.getElementById('fcb-checkout-btn');
    var txt = document.getElementById('fcb-checkout-btn-text');
    if (!btn) return;

    if (filled === 2) {
      btn.disabled       = false;
      txt.textContent    = 'Checkout — ₱' + formatBundlePrice(CFG.bundlePrice);
    } else if (filled === 1) {
      btn.disabled       = true;
      txt.textContent    = 'Pick 1 More Pair';
    } else {
      btn.disabled       = true;
      txt.textContent    = 'Select 2 Pairs';
    }
  }

  /* ─── Dim non-selected cards when box is full ────────── */
  function renderCards() {
    var full = box[0] && box[1];
    document.querySelectorAll('.fc-bundle-card:not(.fc-bc-hidden)').forEach(function (c) {
      if (full) c.classList.add('fc-bc-dimmed');
      else      c.classList.remove('fc-bc-dimmed');
    });
  }

  /* ─── Checkout ───────────────────────────────────────── */
  window.fcBundleCheckout = function () {
    var btn = document.getElementById('fcb-checkout-btn');
    var txt = document.getElementById('fcb-checkout-btn-text');
    if (btn) btn.disabled = true;
    if (txt) txt.innerHTML = '<span class="fc-bundle-spinner"></span>Loading checkout…';

    var v1 = box[0] && box[0].variantId;
    var v2 = box[1] && box[1].variantId;
    if (!v1 || !v2) {
      if (btn) btn.disabled = false;
      if (txt) txt.textContent = 'Checkout — ₱' + formatBundlePrice(CFG.bundlePrice);
      return;
    }

    clearSavedBox();

    var shopifyRoot  = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var base         = shopifyRoot === '/' ? '' : shopifyRoot.replace(/\/+$/, '');
    var discountQs   = DISCOUNT ? '?discount=' + encodeURIComponent(DISCOUNT) : '';

    // Redirect to native Shopify checkout (bypasses any custom checkout page)
    function goNativeCheckout() {
      window.location.href = base + '/checkout' + discountQs;
    }

    // Fallback: cart permalink adds both items and goes straight to checkout
    // Used when /cart/add.js is unavailable (e.g. 429 rate-limit)
    function goPermalinkCheckout() {
      window.location.href = base + '/cart/' + v1 + ':1,' + v2 + ':1' + discountQs;
    }

    // Step 1 — save existing cart for restore (best-effort; 429s or errors are silently ignored)
    fetch('/cart.js')
    .then(function (r) { return r.ok ? r.json() : { items: [] }; })
    .catch(function ()  { return { items: [] }; })
    .then(function (cart) {
      var existingItems = (cart.items || []).map(function (item) {
        return { id: item.variant_id, quantity: item.quantity };
      });
      if (existingItems.length > 0) {
        try {
          localStorage.setItem('fc_cart_restore', JSON.stringify({
            items:          existingItems,
            bundleVariants: [v1, v2],
            ts:             Date.now(),
          }));
        } catch (e) {}
      }
      // Step 2 — clear cart (best-effort)
      return fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
    })
    .then(function () {
      // Step 3 — add only the 2 bundle items
      return fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          items: [
            { id: v1, quantity: 1 },
            { id: v2, quantity: 1 },
          ],
        }),
      });
    })
    .then(function (r) {
      // Always redirect to native checkout regardless of response status
      if (r.ok) {
        goNativeCheckout();
      } else {
        // /cart/add.js failed (e.g. rate-limited) — use permalink as fallback
        goPermalinkCheckout();
      }
    })
    .catch(function () {
      // Network failure — still send to checkout via permalink
      goPermalinkCheckout();
    });
  };

  /* ─── Helpers ────────────────────────────────────────── */
  function formatPrice(cents) {
    return '₱' + (cents / 100).toLocaleString('en-PH', { minimumFractionDigits: 0 });
  }

  function formatBundlePrice(val) {
    if (!val) return '7,000';
    return Number(val).toLocaleString('en-PH');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isLightColor(hex) {
    if (!hex || hex.charAt(0) !== '#') return false;
    var c = hex.substring(1);
    if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
    var r = parseInt(c.substr(0,2),16);
    var g = parseInt(c.substr(2,2),16);
    var b = parseInt(c.substr(4,2),16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 200;
  }

  /* ─── Event delegation for Add to Box button ────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fc-bundle-add-btn');
    if (!btn || btn.disabled || btn.classList.contains('fc-added')) return;
    window.fcBundleOpenPicker(btn);
  });

  /* ─── Close modals on backdrop click ────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var pickerOverlay  = document.getElementById('fcb-picker-modal');
    var replaceOverlay = document.getElementById('fcb-replace-modal');

    if (pickerOverlay) {
      pickerOverlay.addEventListener('click', function (e) {
        if (e.target === pickerOverlay) window.fcBundleClosePicker();
      });
    }
    if (replaceOverlay) {
      replaceOverlay.addEventListener('click', function (e) {
        if (e.target === replaceOverlay) window.fcBundleCloseReplace();
      });
    }

    // Restore saved bundle box from localStorage
    loadBox();
    // Initial render
    renderOverlay();
    renderCards();
  });

})();